import { render } from "./LoginContainerImage.vue?vue&type=template&id=2bf15585"
import script from "./LoginContainerImage.vue?vue&type=script&scoped=true&lang=js"
export * from "./LoginContainerImage.vue?vue&type=script&scoped=true&lang=js"

import "./LoginContainerImage.vue?vue&type=style&index=0&id=2bf15585&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__